import React from 'react';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react';

const ExtraInfo = ({ extraInfo = [] }) => {
  return extraInfo && extraInfo.length > 0
    ? extraInfo.map(
        i =>
          i.desc && (
            <div key={i.title} className="extra-item">
              <BodyText  className="align-left">{i.title}</BodyText>
              <BodyText  className="align-left">{i.desc}</BodyText>
            </div>
          )
      )
    : null;
};

ExtraInfo.propTypes = {
  extraInfo: PropTypes.array
};

export default ExtraInfo;
